<template>
    <div class="hub-listings">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Hub Listing</h2>
                </b-col>
                <b-col cols="6" class="text-right">
                    <base-button v-show="backButton" type="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </base-button>
                    <b-button variant="primary" class="btn-header" @click="toggleCreateModal()">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <hub-listing-table></hub-listing-table>
        </b-container>

        <!-- Create new hub modal -->
        <modal :show.sync="modals.create_hub_form" modalClasses="medium-sized-modal">
            <h6 slot="header" class="modal-title">Add New Hub</h6>
            <b-form @submit.prevent="createData">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Hub Name:" label-cols-xl="3">
                            <b-form-input
                            v-model="form.name"
                            placeholder="Enter name"
                            required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Manager:" label-cols-xl="3">
                            <el-select v-model="form.hub_manager" filterable placeholder="Select Hub Manager">
                                <el-option v-for="option in userList"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id">
                                </el-option>
                            </el-select>
                        </b-form-group> 
                    </b-col>
                </b-row>
                <div>
                    <b-button type="button" class="btn btn-secondary float-right mx-2" @click="toggleCreateModal()">Back/Close</b-button>
                    <b-button type="submit" variant="primary" class="btn btn-primary float-right mx-2">Save</b-button>
                </div>
            </b-form>
            <template slot="footer">
                <div></div>
            </template>
        </modal>
    </div>
</template>
<script>
    import { Select, Option } from 'element-ui'
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
    import HubListingTable from '@/views/Hub/HubListingTable'
    import {axios, services, getHeader } from '@/assets/js/httpImports.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import { useAuthStore } from '@/stores/authStore'
    import { mapActions, mapState } from 'pinia'
    import { useAccessControlStore } from '@/stores/accessControlStore'
    import mainEventBus from '@/assets/js/mainEventBus.js'

    export default {
        mixins: [notifyFunctionMixin],
        components: {
            // RouteBreadCrumb,
            HubListingTable,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data() {
            return {
                backButton: false,
                modals: {
                    create_hub_form: false
                },
                form: {
                    name: '',
                    hub_manager: '',
                    address: '',
                    target: '',
                    type: '',
                    setting: {
                        max_hub_teams_number: '',
                        max_hub_team_members_number: '',
                    },
                },
                selectTypeOptions: [],
                selectHubManagerOptions: [],
            };
        },
        created() {
            if(this.$route.params.token)
            {
                this.backButton = true;
            }
        },
        computed: {
		    ...mapState(useAuthStore, ['auth_user']),
            ...mapState(useAccessControlStore, ['userList']),
        },
        methods: {
            close() {
                if(this.$route.params.token)
                {
                    // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                    window.history.back();
                    window.close();
                }
                else
                {
                    this.$router.back();
                }
            },
            toggleCreateModal() {
                this.modals.create_hub_form = !this.modals.create_hub_form;
            },
            createData() {
                if(!this.form.hub_manager)
                {
                    this.redErrorNotify( '<b>Invalid Input : Hub Manager is Mandatory </b>')
                }
                else
                {
                    const postData = {
                        corporate_id: this.auth_user.account_info.corporate_id,
                        group_name: this.form.name,
                        group_owner_id: this.form.hub_manager,
                        group_metadata: {
                            total_target: 20000,
                            member_target: 20000
                        }   
                    }
                    const str = JSON.stringify(postData);

                    axios.post(services.commission + 'team-group', postData ,{ headers: getHeader() })
                    .then ( response => {
                        if (response.status === 200)
                        {
                            this.$notify({
                                message:
                                '<b>New Hub : ' + response.data.data.group_name + '</b> - Successfully Created.',
                                timeout: 10000,
                                icon: 'ni ni-bell-55',
                                type: 'default',
                            });
                            mainEventBus.$emit('refresh-hub-listing')
                        }
                    })
                    .catch ( error => {
                        this.errorFunction(error, "Add Hub Failed")
                    });
                }
            },
        }
    }
</script>
<style scoped>
>>> .medium-sized-model .modal-footer {
    display: none !important;
}
</style>